/**
 * Grid compatibility component for react-bootstrap v2 migration.
 * Grid was removed in react-bootstrap v2 and replaced with Container.
 * This export provides backward compatibility for existing code.
 */
import Container from "react-bootstrap/Container"
import styled from "styled-components"

export const Grid = styled(Container)`
  padding-right: 16px;
  padding-left: 16px;
  margin-right: auto;
  margin-left: auto;

  /* Mobile first - default is fluid */
  width: auto;
  /* Override B5 Container's max-width which B3 Grid never had */
  max-width: none;

  @media (min-width: 768px) {
    width: 752px;
  }

  @media (min-width: 992px) {
    width: 972px;
  }

  @media (min-width: 1200px) {
    width: 1172px;
  }
`

// export const Grid = Container
export default Container
